import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { WarrantyErrorInfo } from '../fragments';

export default gql`
  mutation createWarrantyError($input: WarrantyErrorCreateInput!) {
    createWarrantyError(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      warrantyError {
        ...WarrantyErrorInfo
      }
    }
  }
  ${WarrantyErrorInfo}
  ${ErrorMessageInfo}
`;
